<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse" aria-expanded="false" aria-controls="collapse">
                Verrekenbare verliezen
            </button>
        </h2>
        <div id="collapse" class="accordion-collapse collapse" aria-labelledby="heading"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Onverrekend verlies box 1</b><br/>
                Kies dit onderwerp als je in vorige jaren een verlies uit werk en woning (box 1) had, bijvoorbeeld als
                de hypotheekrenteaftrek hoger is dan het loon. We noemen dit een 'verlies uit werk en woning'. Wordt dat
                verlies nog niet helemaal verrekend met de inkomens uit werk en woning tot en met {{ this.year - 1 }}?
                Dan kun je het restant van dit verlies verrekenen met uw inkomen uit werk en woning van {{ this.year }}.
                Je moet dan wel aangifte hebben gedaan over de jaren waarin je verlies leed. Of je een verlies uit werk
                en woning hebt, kun je zien op de beschikking die je bij de definitieve aanslag van vorig jaar hebt
                gekregen.
                <div class="space10"></div>
                Een verlies wordt verrekend met een positief inkomen uit dezelfde box. Je kunt dus niet een verlies in
                box 1 verrekenen met inkomen uit box 2. Het verlies wordt eerst verrekend met een positief inkomen uit
                de 3 jaren daarvoor, het oudste jaar eerst.
                <br>Heb je een verlies in box 1? Dan verrekent de Belastingdienst dit met een positief inkomen uit de 3 jaren daarvoor.
                Blijft er daarna nog verlies over? Dan verrekenen zij dat met een positief inkomen uit de 9 jaren
                daarna. In de aangifte inkomstenbelasting {{ this.year }} worden dus verliezen verrekend uit de periode {{ this.year - 9 }} tot en
                met {{ this.year - 1 }}.

                <b>Onverrekend verlies box 2</b><br/>
                Kies dit onderwerp ook als je een nog te verrekenen verlies uit aanmerkelijk belang (box 2) had. Of je
                een verlies uit aanmerkelijk belang hebt, kun je zien op de beschikking die je bij de definitieve aanslag
                van vorig jaar hebt gekregen.
                <div class="space10"></div>

                Je kunt in {{ this.year }} de niet eerder verrekende verliezen box 2 uit de periode {{ this.year - 9 }}
                tot en
                met {{ this.year - 1 }} verrekenen.
                <div class="space10"></div>

                <b>Belastingkorting box 2</b><br/>
                Een nog te verrekenen belastingkorting voor verlies uit aanmerkelijk belang (box 2) kun je verrekenen
                uit de periode {{ this.year - 9 }} tot en met {{ this.year - 1 }}.
                <div class="space10"></div>

                <b>Hoe verlies te verrekenen?</b>
                Je hoeft in principe niet in te vullen om verliezen te verrekenen. De Belastingdienst houdt hier zelf
                rekening mee als je aangifte inkomstenbelasting doet.

                Heb je een verlies in box 2? Dan verrekenen wij dit met een positief inkomen van het jaar ervoor. Blijft
                er daarna nog verlies over? Dan verrekenen wij dat met een positief inkomen uit de 6 jaren daarna.

                Een te verrekenen verlies is persoonlijk. Je kunt niet uw verlies verrekenen met het inkomen van je
                fiscale partner.

                Wil je weten hoeveel te verrekenen verliezen je nog hebt? Dan kun je dit terugzien op de zogenoemde
                'verliesbeschikking' die je bij de definitieve aanslag hebt gekregen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Verlies uit aanmerkelijk belang (box 2)
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Was je inkomen uit aanmerkelijk belang negatief, dan is er sprake van een te verrekenen verlies uit
                aanmerkelijk belang.
                <div class="space10"></div>

                <b>Is het verlies uit aanmerkelijk belang in {{ this.year }} ontstaan?</b><br/>
                De Belastingdienst verrekent dit verlies met positief inkomen uit aanmerkelijk belang van het jaar
                ervoor en eventueel met positief inkomen uit aanmerkelijk belang in de komende 6 jaren.
                <div class="space10"></div>

                Als je heel {{ this.year }} een fiscale partner had, kun je alleen het verlies verrekenen dat je in je
                aangifte aan jezelf toerekent.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Verlies omzetten in belastingkorting (box 2)
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heb je geen aanmerkelijk belang meer, maar nog wel een onverrekend verlies? En wilt je dit verlies
                omzetten in een belastingkorting? Stuur de Belastingdienst dan een brief waarin je hierom vraagt. De
                Belastingdienst stelt de belastingkorting vast in een beschikking. De korting
                is {{ this.korting | number:'1.2-2'}}% van het onverrekende verlies en vermindert de belasting en
                premie volksverzekeringen in box 1. Deze belastingkorting kan tot 9 jaar na het jaar van het ontstaan
                van het verlies worden verrekend met de heffing van box 1. De verrekening met de heffing in box 1 vindt
                pas plaats in het 2e jaar nadat je geen aanmerkelijk belang meer hebt.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Onverrekende buitenlandse bronheffing
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat bij deze vraag om een restant buitenlandse belasting over {{ this.year - 1 }} of eerder op
                rente of dividend waarvoor je in deze aangifte nog aftrek ter voorkoming van dubbele belasting kunt
                krijgen.
                <div class="space10"></div>

                Deze verrekenbare bronheffing is in die jaren ontstaan omdat de bron- of dividendbelasting uit die
                jaren buiten Nederland hoger dan de belasting over je inkomen uit sparen en beleggen.
            </div>
        </div>
    </div>

</div>



